module.exports = __webpack_public_path__ + "static/media/alutrend.8f461407.png";